import React from 'react';
import SurgicalActionPredictor from './SurgicalActionPredictor';

function App() {
  return (
    <div className="App bg-gray-100 min-h-screen p-8">
      <h1 className="text-3xl font-bold text-center mb-8">Surgical Workflow Anticipation with sequence Generation (SWAG)</h1>
      <div className="max-w-6xl mx-auto">
        <SurgicalActionPredictor videoId="41" />
      </div>
    </div>
  );
}

export default App;